import Vue from 'vue';
import Router from 'vue-router';

const Main = resolve => require(['@/pages/layouts/Main'], resolve);
const Home = resolve => require(['@/pages/Home'], resolve);
const ShowBusiness = resolve => require(['@/pages/ShowBussiness'], resolve);
const Science = resolve => require(['@/pages/Science'], resolve);
const NewsOnlineIndex = resolve => require(['@/pages/NewsOnline/index'], resolve);
const NewsOnline = resolve => require(['@/pages/NewsOnline/NewsOnline'], resolve);
const NewsArticles = resolve => require(['@/pages/NewsOnline/NewsArticles'], resolve);
const Partner = resolve => require(['@/pages/Partner'], resolve);
const SocialBenefit = resolve => require(['@/pages/SocialBenefit'], resolve);
const League = resolve => require(['@/pages/League'], resolve);
const AboutUs = resolve => require(['@/pages/AboutUs'], resolve);
const Introduce = resolve => require(['@/pages/Introduce'], resolve);
const objection = resolve => require(['@/pages/objection'], resolve);
const announcement = resolve => require(['@/pages/announcement'], resolve);

Vue.use(Router);

export default new Router({
  //页面跳转显示在顶部   
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  // mode: 'history',
  routes: [
    {
      path: '/',
      component: Main,
      redirect: '/',
      children: [
        {
          path: '/',
          name: '首页',
          component: Home
        },
        {
          path: '/showBusiness',
          name: '业务展示',
          component: ShowBusiness
        },
        {
          path: '/science',
          name: '卡尔科技',
          component: Science
        }, {
          path: '/newsOnline',
          name: '新闻在线',
          component: NewsOnlineIndex,
          redirect: '/newsOnline',
          children: [{
            path: '/newsOnline',
            name: '卡尔动态',
            meta: { keepAlive: true }, //true缓存 false不缓存
            component: NewsOnline
          }, {
            path: '/newsOnline/newsArticles',
            name: '卡尔动态',
            component: NewsArticles
          }]
        },
        // {
        //   path: '/partner',
        //   name: '合作伙伴',
        //   component: Partner
        // }, 
        {
          path: '/socialBenefit',
          name: '社会责任',
          meta: { keepAlive: true },
          component: SocialBenefit
        }, {
          path: '/league',
          name: '商户加盟',
          component: League
        }, {
          path: '/aboutUs',
          name: '关于我们',
          component: AboutUs
        },
        {
          path: '/introduce',
          name: 'App介绍',
          component: Introduce
        },
        {
          path: '/objection',
          name: '异议处理',
          component: objection
        },
        {
          path: '/announcement',
          name: '公告通知',
          component: announcement
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/routes.js